import { QueryEmailProviderArgs } from '@trello/graphql/generated';
import {
  QueryInfo,
  prepareDataForApolloCache,
} from '../prepareDataForApolloCache';
import { clientVersion } from '@trello/config';

export const emailProviderResolver = async (
  obj: object,
  args: QueryEmailProviderArgs,
  context: object,
  info: QueryInfo,
) => {
  const email = args && args.email;

  const response = await fetch(`/checkYourEmail?email=${email}`, {
    headers: {
      'X-Trello-Client-Version': clientVersion,
    },
  });

  const emailProvider = await response.json();

  if (emailProvider.error) {
    throw new Error(emailProvider.error);
  }

  return prepareDataForApolloCache(emailProvider, info);
};
